import { Locale, Market } from '@sccs/types';

export const markets = [
  'bg_BG',
  'cs_CZ',
  'da_DK',
  'de_AT',
  'de_CH',
  'de_DE',
  'de_LI',
  'de_LU',
  'el_GR',
  'en_AU',
  'en_CA',
  'en_CH',
  'en_CY',
  'en_GB',
  'en_HK',
  'en_IE',
  'en_IN',
  'en_MX',
  'en_MY',
  'en_NZ',
  'en_SG',
  'en_TH',
  'en_US',
  'en_ZA',
  'es_ES',
  'es_MX',
  'et_EE',
  'fi_FI',
  'fr_BE',
  'fr_CA',
  'fr_CH',
  'fr_FR',
  'fr_LU',
  'hr_HR',
  'hu_HU',
  'it_CH',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'lv_LV',
  'nl_BE',
  'nl_NL',
  'pl_PL',
  'pt_BR',
  'pt_PT',
  'ro_RO',
  'ru_RU',
  'sk_SK',
  'sl_SI',
  'sv_SE',
  'th_TH',
  'tr_TR',
  'zh_CN',
  'zh_HK',
  'zh_MO',
  'zh_TW',
  'zs_HK',
] as const;

export const MARKETS_TO_LANG: { [market in Market]: string[] } = {
  AT: ['de'],
  AU: ['en'],
  BE: ['nl', 'fr'],
  BG: ['bg'],
  BR: ['pt'],
  CA: ['en', 'fr'],
  CH: ['de', 'fr', 'it'],
  CN: ['en', 'zh_CN'],
  CY: ['en'],
  CZ: ['cs'],
  DE: ['de'],
  DK: ['da'],
  EE: ['et'],
  ES: ['es'],
  FI: ['fi'],
  FR: ['fr'],
  GB: ['en'],
  GR: ['el'],
  HK: ['zh_HK', 'en'],
  HR: ['hr'],
  HU: ['hu'],
  IE: ['en'],
  IN: ['en'],
  IT: ['it'],
  JP: ['ja'],
  KR: ['ko'],
  LI: ['de'],
  LT: ['lt'],
  LU: ['fr', 'de'],
  LV: ['lv'],
  MO: ['en', 'zh_HK'],
  MT: ['en'],
  MX: ['en', 'es'],
  MY: ['en'],
  NL: ['nl'],
  NO: ['no'],
  NZ: ['en'],
  PL: ['pl'],
  PT: ['pt'],
  RO: ['ro'],
  RU: ['ru'],
  SE: ['sv'],
  SG: ['en'],
  SI: ['sl'],
  SK: ['sk'],
  TH: ['en', 'th'],
  TR: ['tr'],
  TW: ['zh'],
  US: ['en'],
  VN: ['vi'],
  ZA: ['en'],
};

export const MARKETS_ISO_TO_PLAIN: { [market in Market]: string } = {
  AT: 'austria',
  AU: 'australia',
  BE: 'belgium',
  BG: 'bulgaria',
  BR: 'brazil',
  CA: 'canada',
  CH: 'switzerland',
  CN: 'china',
  CY: 'cyprus',
  CZ: 'czechia',
  DE: 'germany',
  DK: 'denmark',
  EE: 'estonia',
  ES: 'spain',
  FI: 'finland',
  FR: 'france',
  GB: 'united-kingdom',
  GR: 'greece',
  HK: 'hong-kong',
  HR: 'croatia',
  HU: 'hungary',
  IE: 'ireland',
  IN: 'india',
  IT: 'italy',
  JP: 'japan',
  KR: 'south-korea',
  LI: 'liechtenstein',
  LT: 'lithuania',
  LU: 'luxemburg',
  LV: 'latvia',
  MO: 'macao',
  MT: 'malta',
  MX: 'mexico',
  MY: 'malaysia',
  NL: 'netherlands',
  NO: 'norway',
  NZ: 'new-zealand',
  PL: 'poland',
  PT: 'portugal',
  RO: 'romania',
  RU: 'russia',
  SE: 'sweden',
  SG: 'singapore',
  SI: 'slovenia',
  SK: 'slovakia',
  TH: 'thailand',
  TR: 'turkey',
  TW: 'taiwan',
  US: 'united-states',
  VN: 'vietnam',
  ZA: 'south-africa',
};

export const PROD_DOMAINS = new Map<string, string>([
  ['AT', 'www.mercedes-benz.at'],
  ['AU', 'www.mercedes-benz.com.au'],
  ['BE', 'www.mercedes-benz.be'],
  ['BG', 'www.mercedes-benz.bg'],
  ['BR', 'www2.mercedes-benz.com.br'],
  ['CA', 'www.me.mercedes-benz.ca'],
  ['CH', 'www.mercedes-benz.ch'],
  ['CN', 'www.me.mercedes-benz.com.cn'],
  ['CY', 'www.mercedes-benz.com.cy'],
  ['CZ', 'www.mercedes-benz.cz'],
  ['DE', 'www.mercedes-benz.de'],
  ['DK', 'www.mercedes-benz.dk'],
  ['EE', 'www.mercedes-benz.ee'],
  ['ES', 'www.mercedes-benz.es'],
  ['FI', 'www.mercedes-benz.fi'],
  ['FR', 'www.mercedes-benz.fr'],
  ['GB', 'www.mercedes-benz.co.uk'],
  ['GR', 'www.mercedes-benz.gr'],
  ['HK', 'www.mercedes-benz.com.hk'],
  ['HR', 'www.mercedes-benz.hr'],
  ['HU', 'www.mercedes-benz.hu'],
  ['IN', 'www.mercedes-benz.co.in'],
  ['IE', 'www.mercedes-benz.ie'],
  ['IS', 'www.mercedes-benz.is'],
  ['IT', 'www.mercedes-benz.it'],
  ['JP', 'www.mercedes-benz.co.jp'],
  ['KR', 'www.mercedes-benz.co.kr'],
  ['LI', 'www.me.mercedes-benz.li'],
  ['LT', 'www.mercedes-benz.lt'],
  ['LU', 'www.mercedes-benz.lu'],
  ['LV', 'www.mercedes-benz.lv'],
  ['MO', 'www.me.mercedes-benz-macao.com'],
  ['MT', 'www.mercedes-benz.com.mt'],
  ['MX', 'www.me.mercedes-benz.com.mx'],
  ['MY', 'www.mercedes-benz.com.my'],
  ['NL', 'www.mercedes-benz.nl'],
  ['NO', 'www.mercedes-benz.no'],
  ['NZ', 'www.mercedes-benz.co.nz'],
  ['PL', 'www.mercedes-benz.pl'],
  ['PT', 'www.mercedes-benz.pt'],
  ['RO', 'www.mercedes-benz.ro'],
  ['RU', 'www.mercedes-benz.ru'],
  ['SE', 'www.mercedes-benz.se'],
  ['SG', 'www.mercedes-benz.com.sg'],
  ['SI', 'www.mercedes-benz.si'],
  ['SK', 'www.mercedes-benz.sk'],
  ['TH', 'www.mercedes-benz.co.th'],
  ['TR', 'www.mercedes-benz.com.tr'],
  ['TW', 'www.mercedes-benz.com.tw'],
  ['US', 'www.me.mercedes-benz.com'],
  ['VN', 'www.mercedes-benz.com.vn'],
  ['ZA', 'www.mercedes-benz.co.za'],
]);

export const getLocale = (marketId: string): Locale => {
  const [language, market] = marketId.split('_');
  return { language, market } as Locale;
};

export const getMarketId = (locale: Locale): string => {
  return `${locale.language}_${locale.market}`;
};
